module.exports = __webpack_public_path__ + "79d5e050c00212167ade3c11cfd52a40.png";